import moment from 'moment';
import Vue from 'vue';
import axios from 'axios';
import MoleContainer from '@/funnels/components/mole-container/MoleContainer';
import DayCarousel from '@/funnels/components/day-carousel/DayCarousel';
import Loading from '@/funnels/components/loading/Loading';
import AppointmentPreview from '@/funnels/components/calendar/AppointmentPreview';
import { NAME_VALIDATION } from '../../regex/name';
import { SPAIN_PHONE_PREFIX_CODE } from '@/constants/phone';
import {
  APPOINTMENT_FULL_DATE_FORMAT,
  APPOINTMENT_MONTH_DATE_FORMAT,
} from '@/constants/date';

Vue.component('DayCarousel', DayCarousel);
Vue.component('Loading', Loading);
Vue.component('AppointmentPreview', AppointmentPreview);

export const DATE = new Date();

export default {
  components: { MoleContainer },
  props: {
    timeSlots: {
      type: Array,
      default: () => [],
    },
    needAttentionDatetime: {
      type: String,
      default: null,
    },
  },
  created() {
    this.setNeedAttentionDatetimeData(this);
  },
  computed: {
    title() {
      return 'Reserva tu cita';
    },
    previewLabel() {
      return `${this.form.name}, revisa que los datos sean correctos antes de avanzar`;
    },
    preview() {
      return {
        component: 'div',
        class: 'formulate-form__appointment-preview',
        children: [
          {
            component: 'p',
            class: 'formulate-form__appointment-preview--title',
            children: this.previewLabel,
          },
          {
            component: 'AppointmentPreview',
            datetime: this.form.needAttentionDatetime,
            slotDuration: this.slotDuration,
          },
        ],
      };
    },
    formErrors() {
      if (this.errors.needAttentionDatetime);
      this.errors.needAttentionTime = this.errors.needAttentionDatetime;
      return this.errors;
    },
    needAttentionTimeField() {
      return {
        name: 'needAttentionTime',
        type: 'radio',
        help: 'Selecciona una hora',
        helpPosition: 'before',
        class: 'appointment-time-range',
        options: this.availability,
        errorBehavior: 'submit',
        validation: 'required',
        'validation-messages': {
          required: 'La hora es obligatoria.',
        },
        '@input': 'handleTimeChange',
      };
    },
    needAttentionDayField() {
      return {
        component: 'DayCarousel',
        day: this.form.needAttentionDay,
        latestTimeToSchedule: '17:30',
        '@input': 'handleDayChange',
      };
    },
    needAttentionField() {
      return {
        name: 'needAttentionMonth',
        type: 'month',
        label: this.title,
        placeholder: 'Selecciona una fecha',
        disabled: true,
        validation: 'required',
        min: moment().format('YYYY-MM'),
        'validation-messages': {
          required: 'El mes es obligatorio.',
        },
      };
    },
    confirmNameField() {
      return {
        name: 'name',
        type: 'text',
        help: 'Tu nombre',
        helpPosition: 'before',
        validation: ['required', 'min:2', ['matches', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'El nombre introducido no es válido.',
          required: 'El nombre es obligatorio.',
          min: 'Introduce un nombre de al menos 2 letras.',
        },
      };
    },
    confirmPhoneField() {
      return {
        name: 'phone',
        help: 'Tu teléfono',
        helpPosition: 'before',
        validation: 'required',
        type: 'phone',
        noExample: true,
        showCodeOnList: true,
        noFlags: true,
        borderRadius: 12,
        defaultCountryCode: this.form.prefix || SPAIN_PHONE_PREFIX_CODE,
        translations: {
          phoneNumberLabel: 'Introduzca su número de teléfono',
          countrySelectorLabel: 'código de país',
        },
        validation: 'required|phoneIsValid',
        'validation-messages': {
          required: 'El teléfono es obligatorio.',
          phoneIsValid: 'El número introducido es inválido.',
        },
      };
    },
    submitButtonLabel() {
      return 'Confirmar cita';
    },
  },
  methods: {
    setNeedAttentionDatetimeData({ slotDuration, timeSlots, needAttentionDatetime }) {
      this.slotDuration = slotDuration;
      this.form.needAttentionMonth = moment(needAttentionDatetime).format(
        'YYYY-MM',
      );
      this.form.needAttentionDay = moment(needAttentionDatetime).format(
        'YYYY-MM-DD',
      );
      this.availability = timeSlots.map(function(timeSlot) {
        if (timeSlot.disabled) {
          timeSlot.class = 'formulate-input--disabled';
        }
        return timeSlot;
      });
    },
    fetchAvailability() {
      if (this.form.needAttentionDatetime) {
        this.loading = true;
        this.form.needAttentionTime = null;
        axios
          .patch(this.location, this.form)
          .then(response => {
            this.setNeedAttentionDatetimeData(response.data);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleTimeChange() {
      this.form.needAttentionDatetime = `${this.form.needAttentionDay} ${this.form.needAttentionTime}`;
    },
    handleDayChange(val) {
      const date = moment(val, APPOINTMENT_FULL_DATE_FORMAT);
      this.form.needAttentionDatetime = date
        .format('YYYY-MM-DD hh:mm');
      this.form.needAttentionMonth = date.format(APPOINTMENT_MONTH_DATE_FORMAT);
      this.fetchAvailability();
    },
  },
};
